import React, { useState, useEffect, useCallback, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import trackDriverIcon from "../assets/icons/Green/APX_Transit Canada_80x80.png";
import {
  VerifyTrackDriver,
  HttpError,
  NotFoundError,
  UnknownError,
  TrackDriver,
} from "../functions/ApiCalls";
// import {
//   APIProvider,
//   Map,
//   AdvancedMarker,
//   Pin,
//   useMap,
//   useMapsLibrary,
// } from "@vis.gl/react-google-maps";
import { MapContainer, TileLayer, Marker, Popup, Circle, LayerGroup, useMap} from 'react-leaflet';

import { useLoaderData } from "react-router-dom";
import { useNavigate, useParams } from "react-router";

import carBlack from "../assets/car-black.svg";
import { useTranslation, Trans } from "react-i18next";

//import {Circle}  from "../components/Circle.tsx";

import "../../node_modules/leaflet/dist/leaflet.css";


const leftOrRight = (driverCoordinates, deliveryCoordinates) => {
  if (driverCoordinates.lng < deliveryCoordinates.lng) {
    return "scaleX(1)";
  }

  return "scaleX(-1)";
};

const DriverRoute = ({
  pickupCoordinates,
  deliveryCoordinates,
  driverCoordinates,
}) => {
  const map = undefined;//useMap();
  const routesLibrary = undefined;//useMapsLibrary("routes");
  const [directionsService, setDirectionsService] = useState(undefined);
  const [directionsRenderer, setDirectionsRenderer] = useState(undefined);

  // Initialize directions service and renderer
  useEffect(() => {
    if (!routesLibrary || !map) return;
    setDirectionsService(new routesLibrary.DirectionsService());
    setDirectionsRenderer(
      new routesLibrary.DirectionsRenderer({
        map: map,
        suppressMarkers: true,
        preserveViewport: false,
      })
    );
  }, [routesLibrary, map]);

  // Use directions service
  useEffect(() => {
    const lookupDirections = async () => {
      if (!directionsService || !directionsRenderer) return;

      if (driverCoordinates === undefined) return;

      const response = await directionsService.route({
        origin: pickupCoordinates,
        destination: deliveryCoordinates,
        waypoints: [
          {
            location: driverCoordinates,
            stopover: false,
          },
        ],
        travelMode: "DRIVING",
      });

      directionsRenderer.setDirections(response);
    };

    lookupDirections();
  }, [
    directionsService,
    directionsRenderer,
    pickupCoordinates,
    deliveryCoordinates,
    driverCoordinates,
  ]);
};

const TrackDriverModal = () => {
  const { order, trackingNumber } = useLoaderData();
  const { postalCode } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { pickupCoordinates, deliveryCoordinates } = order.orderDetails;
  const [currentPage, setCurrentPage] = useState(1);
  const [accountNumber, setAccountNumber] = useState("");
  const [deliveryPostalCode, setDeliveryPostalCode] = useState("");
  const [verificationError, setVerificationError] = useState("");
  const [driverCoordinates, setDriverCoordinates] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const postalCodeRef = useRef();
  //const map = undefined;//useMap();
  
  const [center, setCenter] = useState (
      {
        lat: pickupCoordinates && pickupCoordinates.lat !== 0 && deliveryCoordinates && deliveryCoordinates.lat !== 0 ? (pickupCoordinates.lat + deliveryCoordinates.lat) / 2 : 0,//43.1,
        lng: pickupCoordinates && pickupCoordinates.lng !== 0 && deliveryCoordinates && deliveryCoordinates.lng !== 0 ? (pickupCoordinates.lng + deliveryCoordinates.lng) / 2 : 0,//-79.1,
      }
  );
  const [defaultLoc] = useState ({lat:0,lng: 0});
  
  // const center = {
  //   lat: pickupCoordinates.lat !== 0 && deliveryCoordinates.lat !== 0 ? (pickupCoordinates.lat + deliveryCoordinates.lat) / 2 : driverCoordinates.lat,
  //   lng: pickupCoordinates.lng !== 0 && deliveryCoordinates.lng !== 0 ? (pickupCoordinates.lng + deliveryCoordinates.lng) / 2 : driverCoordinates.lng,
  // };

  const doVerification = useCallback(
    (pCode, accNum) => {
      const exec = async () => {
        setIsLoading(true);

        const response = await VerifyTrackDriver(
          trackingNumber,
          accNum/*accountNumber*/,
          pCode
        );

        if (response instanceof HttpError) {
          setVerificationError(t("TrackDriverModal.fetchErrors.httpError"));
          setIsLoading(false);
          return;
        }

        if (response instanceof NotFoundError) {
          setVerificationError(t("TrackDriverModal.fetchErrors.notFoundError"));
          setIsLoading(false);
          return;
        }

        if (response instanceof UnknownError) {
          setVerificationError(t("TrackDriverModal.fetchErrors.unknownError"));
          setIsLoading(false);
          return;
        }

        setIsLoading(false);
        setVerificationError("");// Reset any errors that may have previously shown
        setAccountNumber(accNum/*accountNumber*/);
        setDeliveryPostalCode(pCode);
        setCurrentPage(currentPage + 1);
      };
      exec();
    },
    [accountNumber, currentPage, t, trackingNumber]
  );

  useEffect(() => {
    const exec = async () => {
      postalCodeRef.current.value = postalCode;
      doVerification(postalCode);
    };
    if (postalCode && postalCodeRef.current) {
      exec();
    }
    // doVerification was intentionally left out of the dependency array to prevent an infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postalCode]);

  const verifyPage1 = useCallback(
    async (event) => {
      event.preventDefault();

      const formData = new FormData(event.target);
      const accountNumber = formData.get("accountNumber").trim();
      const destinationPostalCode = formData
        .get("destinationPostalCode")
        .trim();

      if (accountNumber === "" && destinationPostalCode === "") {
        setVerificationError(t("TrackDriverModal.verifyErrors.unknownError"));
        return;
      }

      doVerification(destinationPostalCode, accountNumber);
    },
    [doVerification, t]
  );

  const fetchDriverLocation = useCallback(() => {
    const fetchDriver = async () => {
      const response = await TrackDriver(
        trackingNumber,
        accountNumber,
        deliveryPostalCode
      );
      if (response instanceof HttpError) {
        if (response.response === 429) // If the rate limiting has been hit...
        {
          setVerificationError(t("TrackDriverModal.fetchErrors.tooManyRequests"));
        }
        else{
          setVerificationError(t("TrackDriverModal.fetchErrors.httpError"));
        }
        
        return;
      }

      if (response instanceof NotFoundError) {
        setVerificationError(t("TrackDriverModal.fetchErrors.notFoundError"));
        return;
      }

      if (response instanceof UnknownError) {
        setVerificationError(t("TrackDriverModal.fetchErrors.unknownError"));
        return;
      }

      if (!response.driverCoordinates) {
        setVerificationError(t("TrackDriverModal.fetchErrors.noDriver"));
        return;
      }

      const hasMoved = Math.abs (center.lat - response.driverCoordinates.lat) > 0.001 || Math.abs (center.lng - response.driverCoordinates.lng) > 0.001;
      
      setVerificationError("");
      
      if (hasMoved)
      {
        setDriverCoordinates(response.driverCoordinates);
        center.lat = response.driverCoordinates.lat;
        center.lng = response.driverCoordinates.lng;
  
        if (map)
        {
          map.flyTo(center, map.getZoom(), {
            animate: true,
            duration: 1.5, // Duration in seconds
          });
        }
      }
      // if (map != null)
      // {
      //   map.panTo(center);
      // }
      // else
      // {
      //   console.log ("WARN: Unable to pan the map to the driver's coordinates...", center);
      // }
    };

    fetchDriver();
  }, [accountNumber, deliveryPostalCode, t, trackingNumber, /*map, center*/]);

  useEffect(() => {
    if (currentPage === 2) {
      fetchDriverLocation();
    }
  }, [currentPage, fetchDriverLocation]);

  const handleTrigger = useCallback(() => {
    fetchDriverLocation();
  }, [fetchDriverLocation]);

  const onClose = () => {
    let path = "..";
    if (postalCode) {
      path = "../..";
    }
    navigate(path, { relative: "path" });
  };

  const [map, setMap] = useState(null);
  
  function MapController({ center, zoom }) {
    //const map = useMap();

    useEffect(() => {
      if (map && center) {
        // .flyTo([lat, lng], zoom, options)
        map.attributionControl.setPrefix('Leaflet')// override the default attribution, keep it simple by just specifying the name of the library.
        map.flyTo(center, zoom || map.getZoom(), {
          animate: true,
          duration: 1.5, // Duration in seconds
        });
      }
    }, [center, zoom, map]);

    return null; // This component doesn't render anything
  }
  
  return (
    <Modal
      show={true}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <img
            src={trackDriverIcon}
            alt="sms"
            className="me-2"
            height="40px"
          ></img>
          <Trans i18nKey="TrackDriverModal.title">Track Driver</Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {currentPage === 1 && (
          <form onSubmit={verifyPage1} style={{maxWidth: 'unset'}}>
            <fieldset
              disabled={isLoading}
              className="d-flex justify-content-center flex-column"
            >
              <p style={{width: '94%'}}>
                <Trans i18nKey="TrackDriverModal.prompt">
                  Please enter your account number&nbsp;
                  <b>
                    <u>or</u>
                  </b>
                  &nbsp; postal code so we can verify you.
                </Trans>
              </p>

              <div className="mb-3">
                <label htmlFor="accountNumber" className="form-label">
                  <Trans i18nKey="Generic.accountNumber">Account Number</Trans>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="accountNumber"
                  name="accountNumber"
                  aria-describedby="accountNumber"
                  placeholder="123456"
                  autoFocus={true}
                />
              </div>

              <div style={{position: 'relative', left: '25%'}}>
                <div className="d-flex align-items-center" style={{width: '50%'}}>
                  <hr className="flex-grow-1" style={{width: '25%'}}/>
                  <span className="mx-2 text-muted" style={{fontWeight: '900'}}>OR</span>
                  <hr className="flex-grow-1" style={{width: '25%'}}/>
                </div>
              </div>
              
              <div className="mb-3">
                <label htmlFor="destinationPostalCode" className="form-label">
                  <Trans i18nKey="Generic.destinationPostalCode">
                    Destination Postal Code
                  </Trans>
                </label>
                <input
                    type="text"
                    className="form-control"
                    id="destinationPostalCode"
                    name="destinationPostalCode"
                    aria-describedby="destinationPostalCode"
                    placeholder="L4W 5H8"
                    maxLength="7"
                    ref={postalCodeRef}
                />
              </div>

              {verificationError && (
                  <b>
                    <p className="text-danger text-center">{verificationError}</p>
                  </b>
              )}
              <button className="btn btn-primary" type="submit">
                {isLoading ? "..." : t("Generic.continue")}
              </button>
            </fieldset>
          </form>
          )}

        {currentPage === 2 && (
          <div className="d-flex justify-content-center flex-column">
            {verificationError && (
              <b>
                <p className="text-danger text-center">{verificationError}</p>
              </b>
            )}
            
            <div>
              {/* <h1>Leaflet / OpenStreetMaps</h1> */}
              {center && driverCoordinates && (
                  <>
              <MapContainer center={center != undefined ? center : defaultLoc} zoom={13}
                            dragging={false}
                            doubleClickZoom={false}
                            scrollWheelZoom={false}
                            attributionControl={true}
                            zoomControl={false}
                            style={{height: "400px", width: "100%"}}
                            ref={setMap}>
                <TileLayer 
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    referrerPolicy="strict-origin-when-cross-origin"
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />

                <MapController center={center} zoom={14} />
                
                
                <LayerGroup>                
                  <Circle center={driverCoordinates != undefined ? driverCoordinates : defaultLoc} pathOptions={{fillColor: '#AA0000', color: '#EE4444'}} radius={500}>
                    <Popup>{t("TrackDriverModal.driverLocation")}</Popup>
                  </Circle>
                </LayerGroup>
              </MapContainer>
              <DriverRefresh triggerRefresh={handleTrigger} />
                  </>
            )}
            </div>
            
            
            
            {/*<APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>*/}
            {/*  <Map*/}
            {/*    zoom={13}*/}
            {/*    center={center}*/}
            {/*    gestureHandling={"greedy"}*/}
            {/*    disableDefaultUI={true}*/}
            {/*    style={{ height: "400px", width: "100%", display: "none"}}*/}
            {/*    mapId={process.env.REACT_APP_GOOGLE_MAPS_ID}*/}
            {/*    id="myMap"*/}
            {/*  >*/}
            {/*    {pickupCoordinates && pickupCoordinates.lat !== 0 && pickupCoordinates.lng !== 0 && (*/}
            {/*        <AdvancedMarker*/}
            {/*          position={pickupCoordinates}*/}
            {/*          title={t("TrackDriverModal.pickupLocation")}*/}
            {/*        >*/}
            {/*          <Pin*/}
            {/*            background={"#e25d6e"}*/}
            {/*            borderColor={"#1e89a1"}*/}
            {/*            glyphColor={"#0f677a"}*/}
            {/*          ></Pin>*/}
            {/*        </AdvancedMarker>*/}
            {/*    )}*/}
            
            {/*    {deliveryCoordinates && deliveryCoordinates.lat !== 0 && deliveryCoordinates.lng !== 0 && (*/}
            {/*      <AdvancedMarker*/}
            {/*        position={deliveryCoordinates}*/}
            {/*        title={t("TrackDriverModal.deliveryLocation")}*/}
            {/*      >*/}
            {/*        <Pin*/}
            {/*          background={"#59ba39"}*/}
            {/*          borderColor={"#1e89a1"}*/}
            {/*          glyphColor={"#0f677a"}*/}
            {/*        ></Pin>*/}
            {/*      </AdvancedMarker>*/}
            {/*    )}*/}


            {/*    /!*<Circle center={driverCoordinates} radius={15000} />*!/*/}
            
            {/*    /!*<img*/}
            {/*        src={carBlack}*/}
            {/*        alt="car"*/}
            {/*        height="30px"*/}
            {/*        style={{*/}
            {/*          transform: leftOrRight(*/}
            {/*              driverCoordinates,*/}
            {/*              deliveryCoordinates*/}
            {/*          ),*/}
            {/*        }}*/}
            {/*    ></img>*!/*/}
            {/*    */}
            {/*    /!*driverCoordinates && (                    */}
            {/*        <AdvancedMarker*/}
            {/*            position={driverCoordinates}*/}
            {/*            title={t("TrackDriverModal.driverLocation")} */}
            {/*        >*/}
            {/*          <svg height="100" width="100" xmlns="http://www.w3.org/2000/svg" style={{transform: "translate(25px, 25px)"}}>*/}
            {/*            <circle r="45" cx="50" cy="50" fill="red" opacity="0.5"/>*/}
            {/*            Sorry, your browser does not support inline SVG.*/}
            {/*          </svg>*/}
            {/*        </AdvancedMarker>*/}
            {/*        */}
            {/*    )*!/*/}
            
            
            
            {/*    /!*circle radius unit of measure is meters *!/*/}
            
            {/*    /!*{driverCoordinates && (*/}
            {/*        <AdvancedMarker*/}
            {/*            position={driverCoordinates}*/}
            {/*            title={t("TrackDriverModal.driverLocation")}*/}
            {/*        >*/}
            {/*          */}
            {/*          <Circle center={driverCoordinates} radius={500} fillColor={"red"} fillOpacity={0.35} strokeColor={"red"} strokeOpacity={0.8} strokeWeight={2}/>*/}
            {/*          */}
            {/*        </AdvancedMarker>*/}
            
            {/*    ) /*<Circle center={{lat: 43.6620975895037, lng: -79.6065001710471}} radius={150} />*!/*!/*/}
            
            {/*    /!*<DriverRoute*/}
            {/*      pickupCoordinates={pickupCoordinates}*/}
            {/*      deliveryCoordinates={deliveryCoordinates}*/}
            {/*      driverCoordinates={driverCoordinates}*/}
            {/*    />*!/*/}
            
            
            {/*    { pickupCoordinates && pickupCoordinates.lat !== 0 && pickupCoordinates.lng !== 0 && */}
            {/*      deliveryCoordinates && deliveryCoordinates.lat !== 0 && deliveryCoordinates.lng !== 0 && (*/}
            {/*      <DriverRoute*/}
            {/*          pickupCoordinates={pickupCoordinates}*/}
            {/*          deliveryCoordinates={deliveryCoordinates}*/}
            {/*      />*/}
            {/*    )}*/}
            {/*  </Map>*/}
            {/*  <DriverRefresh triggerRefresh={handleTrigger} />*/}
            {/*</APIProvider>*/}
            <br />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

const refreshRate = 30;

const DriverRefresh = ({ triggerRefresh }) => {
  const [count, setSeconds] = useState(refreshRate);

  const { t } = useTranslation();

  useEffect(() => {
    const timer = setInterval(() => {
      let nextSeconds = count - 1;

      if (nextSeconds === 0) {
        nextSeconds = refreshRate;

        triggerRefresh();
      }

      setSeconds(nextSeconds);
    }, 1000);

    return () => {
      clearInterval(timer);
    };
  });

  return <>{t("TrackDriverModal.locationUpdatingIn", { count })}</>;
};

export default TrackDriverModal;